import { Center, LoadingOverlay, Stepper, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";

const StepLoader = ({ steps }) => {
  const lang = useLanguage(s => s.language)
  const [active, setActive] = useState(0);

  useEffect(() => {
    // Calculate the delay to complete all steps in 5 seconds (5000ms)
    const intervalDelay = 10000 / (steps.length - 1);

    const interval = setInterval(() => {
      setActive((current) => {
        const nextStep = current + 1;
        // If it's the last step, clear the interval and hide the overlay
        if (nextStep >= steps.length - 1) {
          clearInterval(interval);
          return steps.length - 1;
        }
        return nextStep;
      });
    }, intervalDelay);

    // Cleanup function to clear the interval if the component unmounts
    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <LoadingOverlay
      visible={true}
      overlayProps={{ radius: "sm", blur: 2 }}
      loaderProps={{
        children: (
          <Center
            p={"xl"}
            bg={"#ffffff99"}
            style={{ borderRadius: 16, flexDirection: "column" }}
            pb={"sm"}
          >
            <Text size="lg" mb={16}>
              {lang.linkedin_accounts.create.dialog.loading_text}
            </Text>
            <Stepper active={active} orientation="vertical" size="lg">
              {steps.map((step, index) => (
                <Stepper.Step
                  key={index}
                  label={step.label}
                  description={step.description}
                  loading={active === index}
                />
              ))}
            </Stepper>
          </Center>
        ),
      }}
    />
  );
};

export default StepLoader;
